import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_interactive_activities",
  ref: "addInteractiveActivitiesModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_merchant_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_interactive_activities_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_interactive_activities_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_interactive_activities_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row mb-7" }
const _hoisted_11 = { class: "col-md-6 form-group mb-7" }
const _hoisted_12 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_13 = { class: "col-md-6 form-group mb-7" }
const _hoisted_14 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_15 = {
  key: 0,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_16 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_17 = {
  key: 1,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_18 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_19 = {
  key: 2,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_20 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_21 = { class: "col-md-6 form-group mb-7" }
const _hoisted_22 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_23 = { class: "col-md-6 form-group mb-7" }
const _hoisted_24 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_25 = { class: "col-md-6 form-group mb-7" }
const _hoisted_26 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_27 = { class: "col-md-6 form-group mb-7" }
const _hoisted_28 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_29 = { class: "col-md-6 form-group mb-7" }
const _hoisted_30 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_31 = {
  class: "row",
  style: {"margin-left":"0"}
}
const _hoisted_32 = { class: "col-md-8" }
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = { class: "col-md-6 form-group mb-7" }
const _hoisted_35 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("€")
const _hoisted_37 = { class: "col-md-6 form-group mb-7" }
const _hoisted_38 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_39 = { class: "modal-footer flex-center" }
const _hoisted_40 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_41 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_42 = { class: "indicator-label" }
const _hoisted_43 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_44 = { class: "indicator-progress" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("influencerAccount.addInteractiveA")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("interactiveActivities.targetName")), 1),
                    _createVNode(_component_el_form_item, { prop: "target_name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.target_name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.target_name) = $event)),
                          type: "text",
                          placeholder: _ctx.t('common.plsEnter')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("interactiveActivities.targetOwner")), 1),
                    _createVNode(_component_el_form_item, { prop: "target_owner" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.target_owner,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.target_owner) = $event)),
                          filterable: "",
                          remote: "",
                          "reserve-keyword": "",
                          placeholder: _ctx.t('common.plsEnter'),
                          "remote-method": _ctx.searchOwnerItems,
                          loading: _ctx.ownerLoading,
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ownerOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  (!_ctx.props.targetType)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("interactiveActivities.targetType")), 1),
                        _createVNode(_component_el_form_item, { prop: "target_type" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.formData.target_type,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.target_type) = $event)),
                              clearable: "",
                              filterable: "",
                              placeholder: _ctx.t('common.plsSelect'),
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (
                    (_ctx.formData.target_type == 1 || _ctx.formData.target_type == '') &&
                    !_ctx.props.accountId
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("interactiveActivities.influencer")), 1),
                        _createVNode(_component_el_form_item, { prop: "account_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.formData.account_id,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.account_id) = $event)),
                              filterable: "",
                              remote: "",
                              "reserve-keyword": "",
                              placeholder: _ctx.t('common.plsEnter'),
                              "remote-method": _ctx.searchInfluencerItems,
                              loading: _ctx.influencerLoading,
                              disabled: 
                        _ctx.formData.target_type == '' ||
                        _ctx.formData.target_type == null
                      ,
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.influencerOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder", "remote-method", "loading", "disabled"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.target_type == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("interactiveActivities.accountGroups")), 1),
                        _createVNode(_component_el_form_item, { prop: "account_groups_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.formData.account_groups_id,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.account_groups_id) = $event)),
                              filterable: "",
                              remote: "",
                              "reserve-keyword": "",
                              clearable: "",
                              placeholder: _ctx.t('common.plsEnter'),
                              "remote-method": _ctx.searchInfluencerGroupSourceData,
                              loading: _ctx.influencerGroupLoading,
                              disabled: 
                        _ctx.formData.target_type == '' ||
                        _ctx.formData.target_type == null
                      ,
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.influencerGroupOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder", "remote-method", "loading", "disabled"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("interactiveActivities.mbSegmentation")), 1),
                    _createVNode(_component_el_form_item, { prop: "mb_segmentation" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.mb_segmentation,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.mb_segmentation) = $event)),
                          clearable: "",
                          filterable: "",
                          multiple: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"},
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "选项1",
                              value: 1
                            }),
                            _createVNode(_component_el_option, {
                              label: "选项2",
                              value: 2
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("interactiveActivities.start")), 1),
                    _createVNode(_component_el_form_item, { prop: "start" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formData.start,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.start) = $event)),
                          type: "date",
                          clearable: "",
                          placeholder: _ctx.t('common.pickDate'),
                          style: {"width":"100%"},
                          onChange: _cache[7] || (_cache[7] = ($event: any) => (
                        _ctx.commonChangeDefaultDate($event, _ctx.formData, 'start')
                      ))
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("interactiveActivities.closeDate")), 1),
                    _createVNode(_component_el_form_item, { prop: "close_date" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formData.close_date,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.close_date) = $event)),
                          type: "date",
                          clearable: "",
                          placeholder: _ctx.t('common.pickDate'),
                          style: {"width":"100%"},
                          onChange: _cache[9] || (_cache[9] = ($event: any) => (
                        _ctx.commonChangeDefaultDate($event, _ctx.formData, 'close_date')
                      ))
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.t("interactiveActivities.stage")), 1),
                    _createVNode(_component_el_form_item, { prop: "stage" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.stage,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.stage) = $event)),
                          filterable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"},
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stageOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("interactiveActivities.probability")), 1),
                    _createVNode(_component_el_form_item, { prop: "probability" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_el_slider, {
                              modelValue: _ctx.formData.probability,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.probability) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.formData.probability) + "%", 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.t("interactiveActivities.targetAmount")), 1),
                    _createVNode(_component_el_form_item, { prop: "target_amount" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.target_amount,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.target_amount) = $event)),
                          type: "number",
                          placeholder: _ctx.t('common.plsEnter')
                        }, {
                          prepend: _withCtx(() => [
                            _hoisted_36
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.t("interactiveActivities.requriedResources")), 1),
                    _createVNode(_component_el_form_item, { prop: "requried_resources" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.requried_resources,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.requried_resources) = $event)),
                          multiple: "",
                          filterable: "",
                          clearable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requriedResourcesOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_40, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
              ]),
              _createElementVNode("button", _hoisted_41, [
                _createElementVNode("span", _hoisted_42, [
                  _createElementVNode("span", _hoisted_43, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                ]),
                _createElementVNode("span", _hoisted_44, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_45
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}